import React from 'react';
import { useDispatch } from 'react-redux';
import styles from './CustomHeader.module.scss';
import { showHideLane } from '../../../../../../redux/actions/currentProject';
import { useTranslation } from 'react-i18next';
import { COMPLETED_ACCORDANCES_LANE_KEY, CURRENT_ACCORDANCES_LANE_KEY } from '../util';

const isCollapsable = (id: string) => {
  return parseInt(id) !== CURRENT_ACCORDANCES_LANE_KEY;
};

const CustomHeader = ({ ...data }) => {
  const { title, id } = data;
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const handleClick = () => {
    if (isCollapsable(id)) {
      dispatch(showHideLane(parseInt(id), false));
    }
  };
  return (
    <>
      <header
        onClick={handleClick}
        className={
          parseInt(id) !== CURRENT_ACCORDANCES_LANE_KEY
            ? styles.clickableLight
            : parseInt(id) > COMPLETED_ACCORDANCES_LANE_KEY
              ? styles.clickableDark : styles.container
        }
      >
        {title}
      </header>
      {
        data.cards?.length === 0 && (
          <section className={styles.contentWithoutCards}>
            {t('no_agreements_related_to_this_state_have_been_found')}
          </section>
        )
      }
    </>
  );
};

export default CustomHeader;
